import { ReactComponent as Bank1 } from '@src/assets/bank_var_1.svg'
import { ReactComponent as Bank2 } from '@src/assets/bank_var_2.svg'
import { ReactComponent as Bank3 } from '@src/assets/bank_var_3.svg'
import { ReactComponent as Bank4 } from '@src/assets/bank_var_4.svg'
import { ReactComponent as Bank5 } from '@src/assets/bank_var_5.svg'
import style from '../PaymentMethods.module.scss'

export const Mobile = () => (
  <div className={style.mobile}>
    <h2 className={style.bm} id="mobilePay">
      Оплата услуг через мобильный
      телефон
    </h2>

    <div className={style.bank_items_vars}>
      <div className={style.item}>
        <div><Bank1 /></div>
        <a
          target="_blank"
          href="https://belarusbank.by/ru/fizicheskim_licam/cards/uslugi/sms-banking"
          rel="noreferrer"
        >
          SMS–банкинг
          Беларусбанка
        </a>
      </div>

      <div className={style.item}>
        <div><Bank2 /></div>
        <a
          target="_blank"
          href="https://belarusbank.by/ru/fizicheskim_licam/27881"
          rel="noreferrer"
        >
          М–банкинг
          Беларусбанка
        </a>
      </div>

      <div className={style.item}>
        <div><Bank3 /></div>
        <a
          target="_blank"
          href="https://www.priorbank.by/offers/services/digital-bank/ussd-bank-prior-mobile"
          rel="noreferrer"
        >
          SMS-банк
          Prior Mobile Приорбанка
        </a>
      </div>

      <div className={style.item}>
        <div><Bank4 /></div>
        <a
          target="_blank"
          href="https://www.priorbank.by/offers/services/digital-bank/ussd-bank-prior-mobile"
          rel="noreferrer"
        >
          USSD-банк
          Prior Mobile от Приорбанка
        </a>
      </div>

      <div className={style.item}>
        <div><Bank5 /></div>
        <a
          target="_blank"
          href="https://www.alfabank.by/chastnym_licam/distancionnoe_obsluzhivanie/mobilnyj_bank_alfa-mobile/"
          rel="noreferrer"
        >
          Мобильный
          банк Альфа-Мобайл
        </a>
      </div>
    </div>
  </div>
)
